var _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadAgree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2080_7748",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0599976 64V0.0400391H64V64H0.0599976Z",
    fill: "#73BBA3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2080_7748)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 32C64 49.673 49.673 64 32 64C14.327 64 0 49.673 0 32C0 14.327 14.327 0 32 0C49.673 0 64 14.327 64 32Z",
    fill: "#73BBA3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 48H38C37.4696 48 36.9609 47.7893 36.5858 47.4142C36.2107 47.0391 36 46.5304 36 46V40.5C36 40.1022 36.158 39.7206 36.4393 39.4393C36.7206 39.158 37.1022 39 37.5 39H40.561C42.033 39 42.444 37.99 41.475 36.755L33.762 26.926C33.277 26.309 32.639 26 32 26C31.361 26 30.723 26.309 30.238 26.926L22.525 36.755C21.556 37.99 21.967 39 23.439 39H26.5C26.8978 39 27.2794 39.158 27.5607 39.4393C27.842 39.7206 28 40.1022 28 40.5V46C28 46.5304 27.7893 47.0391 27.4142 47.4142C27.0391 47.7893 26.5304 48 26 48H18C12.477 48 8 43.523 8 38C8 32.991 11.687 28.854 16.492 28.126C18.227 21.165 24.502 16 32 16C40.836 16 48 23.164 48 32C50.1217 32 52.1566 32.8429 53.6569 34.3431C55.1571 35.8434 56 37.8783 56 40C56 42.1217 55.1571 44.1566 53.6569 45.6569C52.1566 47.1571 50.1217 48 48 48Z",
    fill: "#629986"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 30C48 21.163 40.836 14 32 14C24.502 14 18.227 19.165 16.492 26.126C11.687 26.854 8 30.991 8 36C8 41.523 12.477 46 18 46H26C26.5304 46 27.0391 45.7893 27.4142 45.4142C27.7893 45.0391 28 44.5304 28 44V38.5C28 38.1022 27.842 37.7206 27.5607 37.4393C27.2794 37.158 26.8978 37 26.5 37H23.439C21.967 37 21.556 35.99 22.525 34.755L30.238 24.926C31.207 23.691 32.793 23.691 33.762 24.926L41.475 34.755C42.444 35.99 42.033 37 40.561 37H37.5C37.1022 37 36.7206 37.158 36.4393 37.4393C36.158 37.7206 36 38.1022 36 38.5V44C36 44.5304 36.2107 45.0391 36.5858 45.4142C36.9609 45.7893 37.4696 46 38 46H48C50.1217 46 52.1566 45.1571 53.6569 43.6569C55.1571 42.1566 56 40.1217 56 38C56 35.8783 55.1571 33.8434 53.6569 32.3431C52.1566 30.8429 50.1217 30 48 30Z",
    fill: "#FFFFFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAgree);
export default __webpack_public_path__ + "static/media/uploadAgree.e43186e3c74d83ed2405d919675eafac.svg";
export { ForwardRef as ReactComponent };